import type React from 'react';

function AdyenIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 1867.19 1867.19" {...props}>
      <title>AdyenIcon</title>

      <g id="Lager_1-2" data-name="Lager 1">
        <path
          d="M23.4,1473.8c0-141.47,0-282.93,0-424.4,.88-6.49,1.96-12.96,2.61-19.47,3.53-35.2,12.41-69.04,26.54-101.4,33.62-77.03,87.4-135.69,161.2-176.03,52.12-28.49,108.18-42.47,167.2-42.79,126.9-.7,253.8-.21,380.71-.21q7.91,0,7.91,8.15c0,186.48-.03,372.95,.1,559.43,0,8.06,.69,16.27,2.35,24.14,9.9,46.81,51.9,81,99.61,81.13,63.55,.16,127.09,.05,190.64,.05,.76,0,1.52-.06,2.27,0,3.09,.22,4.59-1.13,4.44-4.29-.08-1.7,.01-3.4,.01-5.11,0-260.05,.01-520.09-.05-780.14,0-6.4-.4-12.86-1.29-19.19-7.12-50.76-51.07-88.73-102.51-88.73-302.22,0-604.44,0-906.66,0q-8.48,0-8.48-8.7c0-142.6,0-285.2,0-427.8,0-1.51-.5-3.31,.13-4.47,.87-1.6,2.41-3.22,4.05-3.89,1.62-.66,3.72-.15,5.61-.15,466,0,932-.08,1398.01,.25,21.2,.01,42.72,1.95,63.53,5.93,87.32,16.69,159.04,60.25,214.61,129.57,52.62,65.65,77.86,141.25,77.87,225.18,.09,472.81,.04,945.62,.04,1418.43q0,8.12-8,8.13c-84.35,0-168.7,0-253.05,0-388.46,0-776.92-.03-1165.38,.07-31.49,0-62.56-3-93.02-10.95-78.55-20.49-143.26-62.63-193.37-126.38-47.76-60.75-73.5-129.98-76.26-207.47-.11-2.97-.89-5.91-1.35-8.87Z"
          fill="currentColor"
        />
        <rect x="0" width="1867.19" height="1867.19" fill="none" />
      </g>
    </svg>
  );
}

export default AdyenIcon;
